import React, { useState, useEffect } from 'react';
import './Card.css'; // Import CSS file for styling
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function MyVerticallyCenteredModal(props) {
  const { selectedCard } = props;
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {selectedCard.id}. {selectedCard.card_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card-info">
          {selectedCard.image_path !== "" ? (
            <img
              src={`${process.env.REACT_APP_API_URL}/${selectedCard.image_path}`}
              alt="Placeholder"
              className="img-fluid"
            />
          ): (
            <div className="card-info">
            <span className="hint" style={{ color: 'red' }}>
              Für diese Methodenkarte existiert keine Abbildung.
            </span>
          </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ backgroundColor: "#009374" , outline: "none", border: "none" }} onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function Card({ item, isSelected, handleClick }) {
  return (
    <div
      className={`card ${isSelected ? 'selected' : ''}`}
      onClick={() => {
        if (!isSelected) handleClick(item);
      }}
    >
      <div className="card-body">
          <h5 className="card-title">Karte {item.id}:</h5>
          <p className="card-text">{item.card_name}</p>
      </div>

    </div>
  );
}

function CardInfo(props) {
  const [selectedCard, setSelectedCard] = useState(null);
  const {showInfoPopup, setShowInfoPopup} = props;
  const [data, setData] = useState([]);

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setShowInfoPopup(true);
  };

  const handleModalClose = () => {
    setSelectedCard(null);
    setShowInfoPopup(false);
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/cards`)
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  return (
    <div className="card-row">
      <Row>
        {data.map((item) => (
          <Col key={item.id} className='col-6 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
            <Card
              item={item}
              isSelected={selectedCard && selectedCard.id === item.id}
              handleClick={handleCardClick}
            />
          </Col>
        ))}
      </Row>
      {selectedCard && (
        <MyVerticallyCenteredModal
          show={showInfoPopup}
          onHide={handleModalClose}
          selectedCard={selectedCard}
        />
      )}
    </div>
  );
}

export default CardInfo;
